import { render, staticRenderFns } from "./NewsPopup.vue?vue&type=template&id=301604fa&scoped=true"
import script from "./NewsPopup.vue?vue&type=script&lang=js"
export * from "./NewsPopup.vue?vue&type=script&lang=js"
import style0 from "./NewsPopup.vue?vue&type=style&index=0&id=301604fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301604fa",
  null
  
)

export default component.exports